<div class="layout-container">
    <app-operations [isCollapsed]="isCollapsed"></app-operations>
    <div class="main-content">
        <app-top-bar (toggleSidebar)="handleToggle()"></app-top-bar>
        <div class="content-area" [userPermissionHandler]="viewPermissionHandlerData">
            <div class="d-flex justify-content-between align-items-center mb-3">
                <h5 class="fw-semibold">Credit / Debit Card</h5>
                <ejs-tooltip id='tooltipbtnNewCard' target="#targetNewCard" position='LeftCenter'
                    (beforeOpen)="onBeforeOpen($event)">
                    <button id="targetNewCard" class="btn btnAS" [userPermissionHandler]="createPermissionHandlerData"
                        (click)="openCreditCardTypeModal()">New</button>
                </ejs-tooltip>
            </div>
            <hr />
            <div class="container-fluid">
                <div class="row">
                    <div class="col-12 text-start mt-2">
                        <ejs-grid [dataSource]="creditCardTypes" #gridCreditDebit [height]="200" [allowFiltering]="true"
                            (created)="created($event)" class="e-grid-custom" (rowSelected)="onRowSelected($event)">
                            <e-columns>
                                <e-column field="CompanyCreditCardTypeDesc" headerText="Type" width="120"></e-column>
                                <e-column field="ChargeType" headerText="Charge Type" width="150"
                                    [valueAccessor]="chargeTypeAccessor"></e-column>
                                <e-column field="Charge" headerText="Process Charges" textAlign="Right" width="100"
                                    format="N2"></e-column>
                                <e-column field="CardType" headerText="Card Type" width="100"></e-column>
                                <e-column field="IsInactive" headerText="Inactive" width="100" textAlign="Center">
                                    <ng-template #template let-data>
                                        <input type="checkbox" class="form-check-input" [checked]="data.IsInactive"
                                            disabled />
                                    </ng-template>
                                </e-column>
                                <e-column field="Delete" headerText="Delete" width="80" textAlign="Center">
                                    <ng-template #template let-data>
                                        <ejs-tooltip id='tooltipCellDeleteCard' target="#targetDeleteCard"
                                            position='LeftCenter' (beforeOpen)="onBeforeOpen($event)">
                                            <a id="targetDeleteCard"
                                                (click)="deleteCreditCardType(data); $event.stopPropagation()"
                                                [userPermissionHandler]="deletePermissionHandlerData">
                                                <img id="imgDeleteLP" src="./assets/images/delete.svg"
                                                    class="img-fluid" /></a>
                                        </ejs-tooltip>
                                    </ng-template>
                                </e-column>
                            </e-columns>
                        </ejs-grid>
                    </div>
                </div>

                <form [formGroup]="creditCardFeeSettingsForm">
                    <div class="row">
                        <!-- LEFT - EXISTING PROCESSING FEE SETTINGS           -->
                        <div class="col-md-12 col-lg-6 text-start mt-2">
                            <div class="card p-3 shadow-sm">
                                <div class="form-check mb-2">
                                    <input class="form-check-input" type="checkbox" id="chargeCC"
                                        formControlName="ChargeCCProcessingFee">
                                    <label class="form-check-label" for="chargeCC">
                                        Charge CC Processing Fee to Customers
                                    </label>
                                </div>

                                <div class="form-check mb-2">
                                    <input class="form-check-input" type="checkbox" id="chargeSalesTax"
                                        formControlName="ChargeSalesTaxOnCCProcessingFee">
                                    <label class="form-check-label" for="chargeSalesTax">
                                        Charge Sales Tax on CC Processing Fee
                                    </label>
                                </div>

                                <div class="form-check mb-2">
                                    <input class="form-check-input" type="checkbox" id="excludeRental"
                                        formControlName="ExcludeCCProcessingFeeForRental">
                                    <label class="form-check-label" for="excludeRental">
                                        Exclude Credit/ Debit Card Processing fee for Rental Transactions in Payout
                                    </label>
                                </div>

                                <div class="form-check">
                                    <input class="form-check-input" type="checkbox" id="excludePOS"
                                        formControlName="ExcludeCCProcessingFeeForPOS">
                                    <label class="form-check-label" for="excludePOS">
                                        Exclude Credit/ Debit Card Processing fee POS Transactions in Payout
                                    </label>
                                </div>
                            </div>
                        </div>
                        <!-- RIGHT - WR TRANSACTION PROCESSING FEE -->
                        <div class="col-12 col-lg-6 text-start mt-2" *ngIf="enableOnlinePayment">
                            <div class="card p-3 shadow-sm h-100">
                                <div class="fw-semibold mb-2">
                                    CC Processing Fee for Online Rental Payments
                                </div>
                                <div class="form-check mb-3">
                                    <input class="form-check-input" type="checkbox" id="chargeCCProcessingFeeWR"
                                        formControlName="ApplyOnlineRentalCCFee"
                                        (change)="onApplyOnlineRentalCCFeeChange()">
                                    <label class="form-check-label" for="chargeCCProcessingFeeWR">
                                        Charge CC Processing Fee for Online Rental Payments
                                    </label>
                                </div>
                                <div class="row align-items-center g-2">
                                    <div class="col">
                                        <div class="d-flex align-items-center">
                                            <label class="form-label mb-0 me-2 text-nowrap" for="ccFeeTypeWR"> CC Fee
                                                Type </label>
                                            <select id="ccFeeTypeWR" class="form-select form-select-sm flex-grow-1"
                                                formControlName="OnlineRentalCCFeeType" style="width: 180px;"
                                                (change)="onOnlineRentalCCFeeTypeChange()">
                                                <option value="" disabled> --Select-- </option>
                                                <option value="Fixed"> Fixed </option>
                                                <option value="Percentage"> Percentage </option>
                                            </select>
                                        </div>
                                    </div>
                                    <!-- Processing Fee -->
                                    <div class="col-auto">
                                        <div class="d-flex align-items-center">
                                            <label class="form-label mb-0 me-2 text-nowrap" for="ccProcessingFeeWR"> CC
                                                Processing Fee
                                            </label>
                                            <!-- Fixed fee: currency formatter -->
                                            <input *ngIf="creditCardFeeSettingsForm.get('OnlineRentalCCFeeType')?.value === 'Fixed'
      || !creditCardFeeSettingsForm.get('OnlineRentalCCFeeType')?.value" id="ccProcessingFeeFixed"
                                                class="form-control form-control-sm " style="width: 140px;"
                                                formControlName="OnlineRentalCCFee" appCurrencyFormatter
                                                [disabled]="!creditCardFeeSettingsForm.get('ApplyOnlineRentalCCFee')?.value">
                                            <!-- Percentage fee: percentage formatter -->
                                            <input
                                                *ngIf="creditCardFeeSettingsForm.get('OnlineRentalCCFeeType')?.value === 'Percentage'"
                                                id="ccProcessingFeePercentage" class="form-control form-control-sm"
                                                style="width: 140px;" formControlName="OnlineRentalCCFee"
                                                appPercentageFormatter
                                                [disabled]="!creditCardFeeSettingsForm.get('ApplyOnlineRentalCCFee')?.value">
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </form>

                <div class="row">
                    <div class="col-12 text-end mt-2 mb-3">
                        <ejs-tooltip id='tooltipCardFeeSave' target="#btnCardFeeSave" position='LeftCenter'
                            (beforeOpen)="onBeforeOpen($event)">
                            <button class="btn btnAS me-1" id="btnCardFeeSave" (click)="saveCreditCardFeeSettings()"
                                [userPermissionHandler]="editPermissionHandlerData">Save</button>
                        </ejs-tooltip>
                        <button class="btn btn-orange me-1" (click)="onCancel()">Cancel</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
<!-- Modal -->
<div class="modal fade" id="creditCardTypeModal" tabindex="-1" aria-labelledby="creditCardTypeLabel" aria-hidden="true"
    (hidden.bs.modal)="resetCreditCardTypeForm()">
    <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
            <div class="modal-header">
                <h1 class="modal-title fs-5" id="creditCardTypeLabel">Credit / Debit Card</h1>
                <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>

            <form [formGroup]="creditCardTypeForm">
                <div class="modal-body">
                    <div class="row">
                        <div class="col-12 text-start mt-2">
                            <label>Type<span class="text-danger">*</span></label>
                            <input type="text" formControlName="CompanyCreditCardTypeDesc" class="form-control"
                                maxlength="30">
                        </div>
                        <div class="col-12 text-start mt-2">
                            <label>Charge Type<span class="text-danger">*</span></label>
                            <select class="form-select form-control" formControlName="ChargeType">
                                <option value="" disabled>--Select--</option>
                                <option value="Fixed">Fixed ($)</option>
                                <option value="Percentage">Percentage (%)</option>
                            </select>
                        </div>
                        <div class="col-12 text-start mt-2">
                            <label>Amount($ / %)<span class="text-danger">*</span></label>
                            <input type="text" formControlName="Charge" class="form-control" placeholder="0.00"
                                (keydown)="allowOnlyDigits($event, 7, 4)" (focus)="onChargeFocus()"
                                (blur)="onChargeBlur()">
                        </div>
                        <div class="col-12 text-start mt-2">
                            <label>Card Type<span class="text-danger">*</span></label>
                            <select class="form-select form-control" formControlName="CardType">
                                <option value="" disabled>--Select--</option>
                                <option value="Credit Card">Credit Card</option>
                                <option value="Debit Card">Debit Card</option>
                            </select>
                        </div>
                        <div class="col-12 text-start mt-2">
                            <div class="form-check">
                                <input class="form-check-input" type="checkbox" formControlName="IsInactive"
                                    id="isInactive">

                                <label class="form-check-label" for="isInactive">
                                    Inactive
                                </label>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btnAS" (click)="saveCreditCardType()">Save</button>
                    <button type="button" class="btn btn-orange" data-bs-dismiss="modal">Cancel</button>
                </div>
            </form>

        </div>
    </div>
</div>